/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterJewelryType_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterJewelryType_itemSearch";
};
export type SbSharedRefineMenuFilterJewelryType_itemSearch$data = SbSharedRefineMenuFilterJewelryType_itemSearch;
export type SbSharedRefineMenuFilterJewelryType_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterJewelryType_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterJewelryType_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterJewelryType_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '552b1d61a4b7d66bb2dcb31afc721259';
export default node;
